import wx from 'weixin-js-sdk'
const { VUE_APP_WX_ID } = process.env
export default {
    data() {
        return {
            openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
            ],
            appId: VUE_APP_WX_ID, //'wx1d84b11035479230', // wx6bd271c4cc988570
            timestamp: '',
            nonceStr: '',
            jsapiTicket: '',
            shareImgSrc: `${location.origin}/assets/wxshare/logo.png`, // 默认分享缩略图
        }
    },
    methods: {
        wxConfig() {
            const self = this
            wx.config({
                debug: false, // true 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: this.appId, // 必填，公众号的唯一标识
                timestamp: this.timestamp, // 必填，生成签名的时间戳
                nonceStr: this.nonceStr, // 必填，生成签名的随机串
                signature: this.signature, // 必填，签名
                jsApiList: self.jsApiList, // 必填，需要使用的JS接口列表
                openTagList: self.openTagList, //  填入开放标签名
            })
        },
        // getSignature() {
        //     let pageUrl = encodeURIComponent(location.href.split('#')[0])
        //     let str = `jsapi_ticket=${this.jsapiTicket}&noncestr=${this.nonceStr}&timestamp=${this.timestamp}&url=${pageUrl}`
        //     let sha1Str = sha1(str)
        //     return sha1Str
        // },
        wxShare(data) {
            if (!data) return
            const self = this
            self.wxConfig()
            wx.ready(function () {
                // ready接口处理成功验证
                console.log('wx:ready')
                const title = data.title
                const desc = data.desc
                const link = data.link || location.href
                const imgUrl = data.imgUrl || self.shareImgSrc
                console.log('shareImgSrc-------->', data, imgUrl)
                if (wx.onMenuShareAppMessage) {
                    wx.onMenuShareAppMessage({
                        title: title,
                        desc: desc,
                        link: link,
                        imgUrl: imgUrl,
                        type: '', // 分享类型,music、video或link，不填默认为link
                        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                        success: function () {
                            console.log('wx:onMenuShareAppMessage')
                        },
                    })
                    wx.onMenuShareTimeline({
                        title: title,
                        link: link,
                        imgUrl: imgUrl,
                        success: function () {
                            console.log('onMenuShareTimeline')
                        },
                    })
                } else {
                    wx.updateAppMessageShareData({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: imgUrl, // 分享图标
                        success: function () {
                            console.log('updateAppMessageShareData')
                        },
                    })
                    wx.updateTimelineShareData({
                        title: title,
                        desc: desc, // 分享描述
                        link: link,
                        imgUrl: imgUrl,
                        success: function () {
                            console.log('updateTimelineShareData')
                        },
                    })
                }
                wx.onMenuShareQQ({
                    title: title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl,
                    success: function () {
                        console.log('onMenuShareQQ')
                    },
                })
                wx.onMenuShareWeibo({
                    title: title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl,
                    success: function () {
                        console.log('onMenuShareWeibo')
                    },
                })
            })
        },
    },
}
